import React from "react";
import { Bird, Wrench, PaintRoller, Key, Truck, Snowflake, MapPin, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Taubenabwehr",
  description: "[PLATZHALTER: Effektive und tierschutzgerechte Taubenabwehrsysteme für Ihre Immobilien.]",
  icon: Bird,
  span: "col-span-1 row-span-1"
}, {
  title: "Reparaturen & Montage",
  description: "[PLATZHALTER: Schnelle Kleinreparaturen und fachgerechte Montagearbeiten im und am Gebäude.]",
  icon: Wrench,
  span: "col-span-1 row-span-1"
}, {
  title: "Renovierungsarbeiten",
  description: "[PLATZHALTER: Malerarbeiten, Ausbesserungen und Schönheitsreparaturen für einen gepflegten Eindruck.]",
  icon: PaintRoller,
  span: "col-span-1 row-span-1"
}, {
  title: "Hausmeisterservice",
  description: "[PLATZHALTER: Umfassende Objektbetreuung, Kontrollgänge und Ansprechpartner für Mieter vor Ort.]",
  icon: Key,
  span: "col-span-1 row-span-1"
}, {
  title: "Kleintransporte",
  description: "[PLATZHALTER: Zuverlässige Transporte von Möbeln, Akten oder Sperrgut in der Region.]",
  icon: Truck,
  span: "col-span-1 row-span-1"
}, {
  title: "Winterdienst",
  description: "[PLATZHALTER: Zuverlässige Räumung und Streuung von Gehwegen und Zufahrten gemäß Satzung.]",
  icon: Snowflake,
  span: "col-span-1 row-span-1"
}];
export default function RegionalObjectServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="regionale-objekt-services" className="bg-background py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] bg-secondary/30 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary/50 text-primary text-sm font-medium mb-6">
            <MapPin className="w-4 h-4" />
            <span>Regionaler Service</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6">
            Regionale Objekt-Services
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">Wir bieten Ihnen im regionalen Umkreis weitere praktische Dienstleistungen rund um den Werterhalt und die Betreuung Ihrer Immobilie.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 auto-rows-fr">
          {services.map((service, index) => {
          const delayClass = `delay-${index * 100}`;
          return <div key={index} data-index={index} className={`${service.span} transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${index * 100}ms`
          }}>
                <Card className="h-full group hover:-translate-y-2 transition-all duration-300 hover:shadow-lg border-border/50 bg-card/50 backdrop-blur-sm overflow-hidden">
                  <CardHeader>
                    <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/5 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                      <service.icon className="w-6 h-6" />
                    </div>
                    <CardTitle className="text-xl font-semibold group-hover:text-primary transition-colors">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    
                  </CardContent>
                  {}
                  <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-bl from-secondary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </Card>
              </div>;
        })}
        </div>

        
      </div>
    </section>;
}